import { gql } from "@apollo/client"

export const GET_MY_USER_NOTIFICATIONS = gql`
  query getUserNotifications {
    myUser {
      id
      email
      notifyViaEmail
      notificationsEnabled
      notificationMessages {
        ... on SingleDataPlanNotificationMsgType {
          id
          message
          read
          createdAt
          apiPlanId
        }
        ... on SharedDataPlanNotificationMsgType {
          id
          message
          read
          createdAt
          apiPlanId
        }
      }
    }
  }
`
